import React, { InputHTMLAttributes } from 'react'
import styled from 'styled-components'

type Props = InputHTMLAttributes<HTMLInputElement> & {
  value: string
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void
  error?: string | null
}

const Input = styled.input<{ hasError: boolean }>`
  padding: 0.5rem;
  border-radius: 0.375rem;
  border: 1px solid ${props => (props.hasError ? 'red' : '#d1d5db')};
  outline: none;
  &:focus {
    border-color: ${props => (props.hasError ? 'red' : '#3b82f6')};
    box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.5);
  }
`

const ErrorMessage = styled.div`
  color: red;
  margin-top: 0.25rem;
  font-size: 0.875rem;
`

const Wrapper = styled.div`
  margin: 18px 0;
`

export const InputField: React.FC<Props> = ({
  value,
  onChange,
  error,
  ...props
}) => {
  return (
    <Wrapper>
      <Input value={value} onChange={onChange} hasError={!!error} {...props} />
      {error && <ErrorMessage>{error}</ErrorMessage>}
    </Wrapper>
  )
}
